/* ============================================================
   BETH HAMIKDASH — pluie de briques au scroll
   Canvas FIXE plein écran (toute la page, pas seulement le hero),
   transparent, pointer-events:none, briques sable/or.
   100% autonome : ne dépend d'AUCUN élément de la page,
   s'initialise tout seul quand le DOM est prêt.
   ============================================================ */
(function(){
  'use strict';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if(reduce) return;

  function init(){
    if(!document.body) return;
    var canvas = document.createElement('canvas');
    canvas.id = 'brickRain';
    canvas.setAttribute('aria-hidden','true');
    canvas.style.cssText = 'position:fixed;top:0;left:0;width:100vw;height:100vh;pointer-events:none;z-index:60;display:block;';
    document.body.appendChild(canvas);
    var ctx = canvas.getContext('2d');

    var DPR = Math.min(window.devicePixelRatio || 1, 2);
    var W, H;
    function resize(){
      W = window.innerWidth; H = window.innerHeight;
      canvas.width = W * DPR; canvas.height = H * DPR;
      ctx.setTransform(DPR,0,0,DPR,0,0);
    }
    resize();
    window.addEventListener('resize', resize);

    // palette sable / or (corps, goujons, liseré)
    var COLORS = [
      ['#e9d7ab','#d9c188','#b89a55'],
      ['#dfc68c','#cfb070','#a98a45'],
      ['#d4b97a','#c2a35f','#9c7e3c'],
      ['#cda452','#ba9040','#8f6c28'],
      ['#c79a3c','#b3862e','#85631f']
    ];

    var bricks = [];
    var MAX = 20;

    function rr(x,y,w,h,r){
      ctx.beginPath();
      ctx.moveTo(x+r,y);
      ctx.arcTo(x+w,y,x+w,y+h,r);
      ctx.arcTo(x+w,y+h,x,y+h,r);
      ctx.arcTo(x,y+h,x,y,r);
      ctx.arcTo(x,y,x+w,y,r);
      ctx.closePath();
    }

    function spawn(){
      if(bricks.length >= MAX) return;
      var w = 24 + Math.random()*20;
      bricks.push({
        x: Math.random()*W,
        y: -50,
        w: w,
        h: w*0.55,
        vy: 1.1 + Math.random()*1.5,
        rot: (Math.random()-.5)*1.1,
        vr: (Math.random()-.5)*0.035,
        a: 0.45 + Math.random()*0.4,
        c: COLORS[(Math.random()*COLORS.length)|0],
        sway: Math.random()*6.28,
        swayAmp: 0.2 + Math.random()*0.5
      });
    }

    function drawBrick(b){
      ctx.save();
      ctx.translate(b.x, b.y);
      ctx.rotate(b.rot);
      ctx.globalAlpha = b.a;
      var w=b.w, h=b.h;
      // goujons (studs) sur le dessus
      var sw=w*0.26, sh=h*0.32;
      ctx.fillStyle = b.c[1];
      rr(-w*0.34, -h/2 - sh + 1, sw, sh, 2); ctx.fill();
      rr( w*0.08, -h/2 - sh + 1, sw, sh, 2); ctx.fill();
      // corps
      ctx.fillStyle = b.c[0];
      rr(-w/2, -h/2, w, h, 3); ctx.fill();
      ctx.strokeStyle = b.c[2];
      ctx.lineWidth = 1;
      ctx.stroke();
      // reflet
      ctx.globalAlpha = b.a * 0.5;
      ctx.fillStyle = '#fff7e0';
      rr(-w/2 + 2.5, -h/2 + 2.5, w*0.42, 2.4, 1.2); ctx.fill();
      ctx.restore();
    }

    // l'énergie du scroll pilote l'apparition — sur TOUTE la page
    var lastY = window.pageYOffset || 0;
    var spawnAcc = 0;        // accumulateur fractionnaire
    var PER_BRICK = 105;     // px scrollés (vers le bas) par brique
    var running = false;

    window.addEventListener('scroll', function(){
      var y = window.pageYOffset || 0;
      var dy = y - lastY;
      if(dy > 0){ spawnAcc += dy / PER_BRICK; ensureRunning(); }
      lastY = y;
    }, {passive:true});

    function ensureRunning(){
      if(!running){ running = true; requestAnimationFrame(frame); }
    }

    function frame(){
      ctx.clearRect(0,0,W,H);

      if(spawnAcc >= 1){
        var n = Math.min(2, Math.floor(spawnAcc));
        for(var s=0;s<n;s++) spawn();
        spawnAcc -= n;
      }
      spawnAcc *= 0.9;
      if(spawnAcc < 0.05) spawnAcc = 0;

      for(var i=bricks.length-1;i>=0;i--){
        var b = bricks[i];
        b.sway += 0.03;
        b.x += Math.sin(b.sway) * b.swayAmp;
        b.y += b.vy;
        b.vy += 0.045;
        b.rot += b.vr;
        if(b.y > H + 70){ bricks.splice(i,1); }
        else drawBrick(b);
      }

      if(bricks.length > 0 || spawnAcc > 0){
        requestAnimationFrame(frame);
      } else {
        running = false;
        ctx.clearRect(0,0,W,H);
      }
    }
  }

  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
